const types = {
  DISPLAY: 'app/popup/DISPLAY',
  HIDE: 'app/popup/HIDE',
};

export default types;
